import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "kalkulator",
  class: "kalkulator__container"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 col-sm-12 col-lg-4 columns" }
const _hoisted_4 = { class: "col-12 col-sm-12 col-lg-8 columns" }
const _hoisted_5 = { class: "row mt-0" }
const _hoisted_6 = { class: "col" }

import stawkaPradu from "./components/stawkaPradu.vue";
import TheFiltry from "./components/TheFiltry.vue";
import FiltrRodzaj from "./components/FiltrRodzaj.vue";
import TabelaKoparek from "./components/tabelaKoparek.vue";

import { useStore } from "vuex";
import { onMounted } from "vue";

const isAsic = true;


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();
onMounted(() => {
  console.log("Version: 0.3.0");
  store.dispatch("miners/getMinersFromDB");
  store.dispatch("miners/getExchangeRate");
  store.dispatch("miners/fetchMiners", isAsic);
  store.dispatch("miners/fetchMiners", !isAsic);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(stawkaPradu)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(TheFiltry)
      ])
    ]),
    _createVNode(FiltrRodzaj),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(TabelaKoparek)
      ])
    ])
  ]))
}
}

})